import React from 'react'

const FilterChips = ({ setFilterModalOpen, removeFilter, filters}) => {

  function formatDate(date) {
    const options = { day: "2-digit", month: "short", year: "numeric" };
    return new Intl.DateTimeFormat("en-GB", options).format(date);
  }

  const flattenedChips = Object.keys(filters).reduce((acc, filterKey) => {
    const filterValue = filters[filterKey];
    if (Array.isArray(filterValue)) {
      return acc.concat(
        filterValue.map((filterVal) => ({ filterKey, filterVal }))
      );
    } else if (filterValue && typeof filterValue === "object") {
      return acc.concat(
        Object.keys(filterValue).map((filterkeys) => ({
          filterKey,
          dateKey: filterkeys,
          filterVal: filterValue[filterkeys],
        }))
      );
    } else {
      return acc.concat({ filterKey, filterVal: filterValue });
    }
  }, []);

  const displayedChips = flattenedChips.slice(0, 9);

  return (
    <div className="filter-result d-flex align-center">
          {displayedChips.map(
            ({ filterKey, filterVal, dateKey = "" }, index) => {
              return filterVal instanceof Date ? (
                <span key={index} className="d-flex align-center">
                  {formatDate(filterVal).toLocaleString()}
                  <button
                    className="d-flex align-center"
                    onClick={() => removeFilter(filterKey, filterVal, dateKey)}
                  >
                    <span className="material-symbols-outlined">close</span>
                  </button>
                </span>
              ) :  filterVal ? (
                <span key={index} className="d-flex align-center">
                  {filterVal}
                  <button
                    className="d-flex align-center"
                    onClick={() => removeFilter(filterKey, filterVal, dateKey)}
                  >
                    <span className="material-symbols-outlined">close</span>
                  </button>
                </span>
              ) : null;
            }
          )}

          {/* Show "Show All" button if there are more than 10 chips */}
          {flattenedChips.length > 9 && (
            <button onClick={() => setFilterModalOpen(true)}>Show All</button>
          )}
        </div>
  )
}

export default FilterChips